
import { initVideoIcon } from '~/mixins/inlineVideoIcon'

export default {
  mixins: [initVideoIcon],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      playerReady: false,
      playing: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
      this.initVideoIcon('.was-video-icon', () => this.openModal())
    })
  },
  methods: {
    initAnimation() {
      // reveal animation
      const tl = this.$gsap.timeline({ delay: 0.5 })

      tl.from(this.$refs['header-title'], {
        autoAlpha: 0,
        xPercent: -10,
        duration: 0.6,
        ease: 'back',
      })
      tl.from(this.$refs['header-button'], {
        duration: 0.5,
        autoAlpha: 0,
      })
      tl.from(
        this.$refs['header-img'],
        {
          duration: 0.5,
          autoAlpha: 0,
        },
        '<'
      )

      // const gsap = this.$gsap
      // const SplitText = this.$SplitText
      // function parallaxIt(e, target, movement) {
      //   const $this = document.querySelector('#sections-header')
      //   const relX = e.pageX - $this.offsetLeft
      //   const relY = e.pageY - $this.offsetTop
      //   gsap.to(target, 1, {
      //     x: ((relX - $this.offsetWidth / 2) / $this.offsetWidth) * movement,
      //     y: ((relY - $this.offsetHeight / 2) / $this.offsetHeight) * movement,
      //   })
      // }
      // function mousemoveHandler(e) {
      //   const isSafari =
      //     navigator.vendor &&
      //     navigator.vendor.includes('Apple') &&
      //     navigator.userAgent &&
      //     !navigator.userAgent.includes('CriOS') &&
      //     !navigator.userAgent.includes('FxiOS')
      //   if (!isSafari) {
      //     parallaxIt(e, '.header-text', -40)
      //   }
      //   parallaxIt(e, '.header-image', -100)
      //   parallaxIt(e, '#circle-container', 30)
      // }
      // this.$refs.lead.addEventListener('mousemove', mousemoveHandler)
      // gsap.set(this.$refs['header-image'], {
      //   scrollTrigger: this.$refs['header-image'],
      //   scaleX: 1.3,
      //   scaleY: 1.3,
      // })
      // gsap.from(this.$refs['header-image'], 1.5, {
      //   scrollTrigger: this.$refs['header-image'],
      //   alpha: 0,
      //   scaleX: 1.6,
      //   scaleY: 1.6,
      //   ease: 'Power3.easeInOut',
      // })
      // gsap.from('#circle', 1.5, {
      //   scaleX: 0.9,
      //   scaleY: 0.9,
      //   ease: 'Power3.easeInOut',
      // })
      // gsap.from('#circle-container', 1.5, {
      //   y: '-=50',
      //   ease: 'Power3.easeInOut',
      // })
      // gsap.from('#circle-border', 0.75, {
      //   alpha: 0,
      //   scaleX: 0.9,
      //   scaleY: 0.9,
      //   ease: 'Power3.easeInOut',
      // })
      // gsap.from('.header-text', 0.75, {
      //   scrollTrigger: this.$refs.header,
      //   alpha: 0,
      //   delay: 0.75,
      //   scaleX: 1.1,
      //   scaleY: 1.1,
      //   ease: 'Power3.easeInOut',
      // })
      // const splitTimeline = gsap.timeline({})
      // const split = new SplitText('.split-text')
      // splitTimeline.from(split.lines, 0.75, {
      //   delay: 0.75,
      //   alpha: 0,
      //   y: '+=30',
      //   ease: 'Power3.easeInOut',
      //   stagger: 0.35,
      // })
    },
    openModal() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.playing = false
    },
    onLoad() {
      // set classes for iframe
      this.$refs.player.$el
        .querySelector('iframe')
        .classList.add(
          'rounded-xl',
          'absolute',
          'w-full',
          'h-full',
          'top-0',
          'left-0'
        )

      this.playerReady = true
    },
    playingVideo() {
      this.playing = true
    },
  },
}
